import { AlertTriangle } from 'lucide-react';

interface ApiErrorProps {
  message?: string;
  onRetry?: () => void;
  showEmergencyInfo?: boolean;
}

export default function ApiError({
  message = 'Something went wrong. Please try again.',
  onRetry,
  showEmergencyInfo = false,
}: ApiErrorProps) {
  return (
    <div className="card border border-red-200">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-5 h-5 text-red-600" />
        </span>
        <div>
          <h3 className="font-bold text-navy">Error</h3>
          <p className="text-gray-500 text-sm mt-1">{message}</p>
        </div>
      </div>

      {showEmergencyInfo && (
        <div className="mt-4 bg-red-50 rounded-lg p-4">
          <p className="text-sm font-semibold text-red-800 mb-2">If this is an emergency:</p>
          <ul className="text-sm text-red-700 space-y-1">
            <li>Emergency: <a href="tel:911" className="underline font-bold">911</a></li>
            <li>Health Hotline: <a href="tel:919" className="underline font-bold">919</a></li>
            <li>PMH: <a href="tel:+12423222861" className="underline font-bold">(242) 322-2861</a></li>
          </ul>
        </div>
      )}

      {onRetry && (
        <button onClick={onRetry} className="btn btn-primary btn-sm mt-4">
          Try Again
        </button>
      )}
    </div>
  );
}
